import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ_ITEMS = [
  {
    question: 'Wie schnell bekomme ich eine Rückmeldung?',
    answer: 'Sehr schnell. Rufen Sie an oder schreiben Sie per WhatsApp – wir melden uns zeitnah zurück.'
  },
  {
    question: 'Kann ich auch abends oder am Wochenende schreiben?',
    answer: 'Ja. Schreiben Sie uns über WhatsApp, auch außerhalb der üblichen Geschäftszeiten. Wir antworten so schnell wie möglich.'
  },
  {
    question: 'Muss ich etwas vorbereiten?',
    answer: 'Es hilft, wenn Sie Unfalltag, Schadenart und Standort des Fahrzeugs wissen. Aber keine Sorge – wenn etwas fehlt, klären wir das im Gespräch.'
  },
  {
    question: 'Kommt ihr direkt vor Ort?',
    answer: 'Ja. Die Begutachtung findet dort statt, wo sich Ihr Fahrzeug befindet – bundesweit.'
  },
  {
    question: 'Was passiert nach der Kontaktaufnahme?',
    answer: 'Wir klären Ihre Situation, geben eine erste Einschätzung und vereinbaren bei Bedarf einen Termin vor Ort.'
  },
  {
    question: 'Kann ich auch nur eine kurze Frage stellen?',
    answer: 'Selbstverständlich. Rufen Sie an oder schreiben Sie kurz – wir helfen Ihnen gerne weiter, auch wenn Sie sich noch nicht sicher sind.'
  },
  {
    question: 'Ist die Erstberatung kostenlos?',
    answer: 'Die erste Kontaktaufnahme und Einschätzung ist unverbindlich. Wir klären gemeinsam, welche Schritte für Sie sinnvoll sind.'
  },
  {
    question: 'Welcher Kontaktweg ist am schnellsten?',
    answer: 'Telefonisch erreichen Sie uns am direktesten. Per WhatsApp können Sie jederzeit schreiben – auch außerhalb der üblichen Zeiten.'
  }
];

export const FAQKontakt = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            FAQ
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Häufig gestellte Fragen
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Rund um Kontakt und Ablauf
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-3xl p-10 lg:p-16 shadow-modern-lg">
          <Accordion type="single" collapsible className="w-full space-y-5">
            {FAQ_ITEMS.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`} 
                className="border border-gray-200 rounded-2xl px-7 py-1 data-[state=open]:border-brand-green/40 data-[state=open]:shadow-xl transition-all bg-white"
              >
                <AccordionTrigger className="text-left font-bold text-gray-900 hover:text-brand-green py-6 hover:no-underline text-base lg:text-lg">
                  <div className="flex items-start gap-4">
                    <HelpCircle className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" />
                    <span className="pr-4">{item.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6 pl-10 text-[15px]">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};